import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

type Stats = {
  sources: number;
  lines: number;
  positive: number;
  catalogue: number;
  candidates: number;
};

export default function DashboardStats() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const [sources, lines, positive, catalogue, candidates] = await Promise.all([
        supabase.from("source_documents").select("*", { count: "exact", head: true }),
        supabase.from("import_lines").select("*", { count: "exact", head: true }),
        supabase
          .from("import_lines")
          .select("*", { count: "exact", head: true })
          .gt("dry_unit_price", 0),
        supabase.from("work_items").select("*", { count: "exact", head: true }),
        supabase
          .from("catalogue_candidates")
          .select("*", { count: "exact", head: true })
          .eq("status", "pending")
          .eq("is_current", true)
          .gte("project_count", 2)
          .lte("price_spread_pct", 25),
      ]);

      if (!cancelled) {
        setStats({
          sources: sources.count ?? 0,
          lines: lines.count ?? 0,
          positive: positive.count ?? 0,
          catalogue: catalogue.count ?? 0,
          candidates: candidates.count ?? 0,
        });
      }
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  const values = stats ?? { sources: 0, lines: 0, positive: 0, catalogue: 0, candidates: 0 };

  return (
    <div className="stats-grid">
      <div className="stat card">
        <span>Fontes importadas</span>
        <strong>{stats ? values.sources.toLocaleString("pt-PT") : "—"}</strong>
      </div>
      <div className="stat card">
        <span>Linhas históricas</span>
        <strong>{stats ? values.lines.toLocaleString("pt-PT") : "—"}</strong>
      </div>
      <div className="stat card">
        <span>Referências com PU seco</span>
        <strong>{stats ? values.positive.toLocaleString("pt-PT") : "—"}</strong>
      </div>
      <div className="stat card">
        <span>Candidatos recorrentes</span>
        <strong>{stats ? values.candidates.toLocaleString("pt-PT") : "—"}</strong>
      </div>
      <div className="stat card">
        <span>Artigos normalizados</span>
        <strong>{stats ? values.catalogue.toLocaleString("pt-PT") : "—"}</strong>
      </div>
    </div>
  );
}
